// ==================
// Exemplo de Tape:
// ==================
// {
//   "slug": "xpto",
//   "path": "/hisnek/ivi",
//   "brand_channel": {
//     "background": "",
//     "banner": "//cdn-videos-sp.overmediacast.com/5cf684387cb6a6000b18c3d7/bg.png",
//     "campaign_id": "5cf684387cb6a6000b18c3d6",
//     "client_name": "hisnek",
//     //...
//   },
//   "session_id": "878cb41c-26b6-4dce-8954-9061e232a173",
//   "ovm_config": {
//     "id": "878cb41c-26b6-4dce-8954-9061e232a173",
//     "env": {
//       "@UNIQUE_URL_MODE": true
//     },
//     "policy": {
//       "start": {
//         "id": "start",
//         "video": video.manifest
//       },
//     }
//   }
// }
export function setTape(state, tape) {
  state.tape = tape;
}
